<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    FISCALIZAÇÃO
                    <b-badge variant="warning" class="ml-2">{{ operacao }}</b-badge>
                </span>
            </b-card-header>
            <b-card-body>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <div>
                    <b-row>
                        <b-col sm="12" md="6" lg="6" xl="6">
                            <b-form-group>
                                <label class="required">Contrato</label>
                                <b-form-select
                                    :options="contratos"
                                    v-model="idContrato"
                                    text-field="fornecedor"
                                    value-field="idContrato"
                                ></b-form-select>
                            </b-form-group>
                            <b-form-invalid-feedback>
                                O contrato é obrigatório
                            </b-form-invalid-feedback>
                        </b-col>
                        <b-col sm="12" md="6" lg="6" xl="6">
                            <b-form-group>
                                <label class="required">Processo de fiscalização</label>
                                <b-form-select
                                    :options="processos"
                                    v-model="numeroProcessoFiscalizacao"
                                    text-field="descricao"
                                    value-field="id"
                                ></b-form-select>
                                <b-form-invalid-feedback>
                                    O processo de fiscalização é obrigatório
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <b-form-group>
                                <label class="required">Descrição</label>
                                <b-form-textarea
                                    v-model="descricao"
                                    :rows="4"
                                    maxlength="500"
                                    @input.native="$v.descricao.$touch()"
                                    :state="$v.descricao.$error ? false : null"
                                ></b-form-textarea>
                                <b-form-invalid-feedback>
                                    A Descrição é obrigatória
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label class="required">
                                    Data da fiscalização
                                </label>
                                <date-picker
                                    v-model="dataFiscalizacao"
                                    :config="$datePickerOptions"
                                    v-mask="'##/##/####'"
                                    @input.native="$v.dataFiscalizacao.$touch()"
                                    :state="$v.dataFiscalizacao.$error ? false : null"
                                ></date-picker>
                                <b-form-invalid-feedback>
                                    A Data da fiscalização é obrigatória
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <b-form-group>
                                <label class="required">Observação</label>
                                <b-form-textarea
                                    v-model="observacao"
                                    :rows="4"
                                    maxlength="1000"
                                    @input.native="$v.observacao.$touch()"
                                    :state="$v.observacao.$error ? false : null"
                                ></b-form-textarea>
                                <b-form-invalid-feedback>
                                    A Observação é obrigatória
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </b-card-body>
            <b-card-footer>
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="salvar()"
                    class="mr-2"
                >
                    <i class="fa fa-save"></i> Salvar
                </b-button>          
                  
                <b-button variant="danger" @click.stop="cancelar()" class="mr-2">
                    <span> <i class="fa fa-remove"></i> Cancelar </span>
                </b-button>
            </b-card-footer>            
        </b-card>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import FiscalizacoesServicos from './FiscalizacoesServicos'

export default {

    data() {
        return {
            contratos: [],
            processos: [],
            erros: [],
            numeroProcessoFiscalizacao: null,
            idContrato: '',
            descricao: '',
            observacao: '',
            dataFiscalizacao: null,
            fiscalizacao: null
        }
    },

    methods: {

        limitDescricao() {
            if (this.descricao.length > 500) {
                this.descricao = this.descricao.substring(0, 500)
            }
        },

        limitObservacao() {
            if (this.observacao.length > 1000) {
                this.observacao = this.observacao.substring(0, 1000)
            }
        },

        salvar() {
            let fiscalizacao = {
                idContrato: this.idContrato,
                processoFiscalizacao: this.numeroProcessoFiscalizacao,
                descricao: this.descricao,
                dataFiscalizacao: this.$moment(this.dataFiscalizacao, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss'),
                observacao: this.observacao
            }

            if ('INSERÇÃO' === this.operacao) {
                this.salvarFiscalizacao(fiscalizacao)
            } else {
                fiscalizacao.idFiscalizacao = this.fiscalizacao.idFiscalizacao
                this.alterarFiscalizacao(fiscalizacao)
            }
        },

        cancelar() {
            if (this.fiscalizacao && this.fiscalizacao.idFiscalizacao) {
                this.$router.push({ 
                    name: 'Fiscalizações_Detalhar',
                    params: {
                        fiscalizacaoId: this.fiscalizacao.idFiscalizacao
                    }
                })
            } else {
                // Fallback seguro (volta pra listagem por exemplo)
                this.$router.push({ name: 'Fiscalizações' })
            }
        },

        salvarFiscalizacao(fiscalizacao) {
            this.$store.dispatch('addRequest')

            FiscalizacoesServicos.inserirFiscalizacao(fiscalizacao).then(response => {
                if (response) {
                    if (response.success) {
                        let idFiscalizacao = response.data.idFiscalizacao
                        this.registroSalvoComSucesso(idFiscalizacao)
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        alterarFiscalizacao(fiscalizacao) {
            this.$store.dispatch('addRequest')

            FiscalizacoesServicos.atualizarFiscalizacao(fiscalizacao).then(response => {
                if (response) {
                    if (response.success) {
                        let idFiscalizacao = fiscalizacao.idFiscalizacao
                        this.registroAlteradoComSucesso(idFiscalizacao)
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso(idFiscalizacao) {
            this.$router.push({
                name: 'Fiscalizações_Detalhar',
                params: {
                    fiscalizacaoId: idFiscalizacao
                }
            })
        },

        registroAlteradoComSucesso(idFiscalizacao) {
            this.$router.push({
                name: 'Fiscalizações_Detalhar',
                params: {
                    fiscalizacaoId: idFiscalizacao
                }
            })
        },

        obterContratoPorCodigo(codigoContrato) {
            if (this.contratos && this.contratos.length > 0) {
                let contrato = this.contratos.filter(c => c.codigoContrato === codigoContrato)
                if (contrato && contrato.length > 0) {
                    return contrato[0].idContrato
                }
            }
            return null;
        },

        preencheFormulario() {
            this.numeroProcessoFiscalizacao = this.fiscalizacao.numeroProcessoFiscalizacao
            this.idContrato = this.obterContratoPorCodigo(this.fiscalizacao.codigoContrato),
            this.descricao = this.fiscalizacao.descricao
            this.observacao = this.fiscalizacao.observacao
            this.dataFiscalizacao = this.$moment(this.fiscalizacao.dataFiscalizacao).format('DD/MM/YYYY')
        },

        obterContratos() {
            this.$store.dispatch('addRequest')
            FiscalizacoesServicos.obterContratos().then(response => {
                if (response) {
                    if (response.success) {
                        this.contratos = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter os contratos',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterProcessos() {
            this.$store.dispatch('addRequest')
            FiscalizacoesServicos.obterProcessos().then(response => {
                if (response) {
                    if (response.success) {
                        this.processos = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter os processos',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterFiscalizacao() {
            if (this.ehEdicao) {
                this.$store.dispatch('addRequest')
                FiscalizacoesServicos.obterFiscalizacao(this.$route.params.fiscalizacaoId).then(response => {
                    if (response) {
                        if (response.success) {
                            // this.preencheFormulario(response.data)
                            this.fiscalizacao = response.data
                        } else {
                            this.$toast.error(
                                'Erro ao obter a fiscalização',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        verificarCampoPreenchido(value) {
            if (value == null || value == '' || value == undefined)
                return false
            else
                return true
        }


    },

    created() {
        this.obterContratos()
        this.obterProcessos()
        this.obterFiscalizacao()
    },

    computed: {
        desabilitarBtnSalvar() {
            if (this.$v.$invalid) 
                return true
            else 
                return false
        },

        operacao() {
            if (this.$route.name == 'Fiscalizações_Inserir') {
                return 'INSERÇÃO'
            } else {
                return 'ATUALIZAR'
            }
        },

        descricaoValida() {
            return this.verificarCampoPreenchido(this.descricao)
        },

        observacaoValida() {
            return this.verificarCampoPreenchido(this.observacao)
        },

        dataFiscalizacaoValida() {
            return this.verificarCampoPreenchido(this.dataFiscalizacao);
        },

        ehEdicao() {
            return this.$route.params.fiscalizacaoId !== null && this.$route.params.fiscalizacaoId !== undefined
        },
        
        combinedProps() {
            return [this.fiscalizacao, this.contratos, this.processos];
        },
    },

    validations: {
        numeroProcessoFiscalizacao: {
            required
        },
        idContrato: {
            required,
        },
        descricao: {
            descricaoValida() {
                return this.descricaoValida
            }
        },
        observacao: {
            observacaoValida() {
                return this.observacaoValida
            }
        },
        dataFiscalizacao: {
            dataFiscalizacaoValida() {
                return this.dataFiscalizacaoValida
            }
        }            
    },

    watch: {
        combinedProps: {
            handler(newVal) {
                if (newVal.every(val => val !== null && !(Array.isArray(val) && val.length === 0))) {
                    this.preencheFormulario()
                }
            },
            deep: true, // Necessário para observar mudanças nos valores dentro do array
            immediate: true, // Opcional: executa no início
        }
    }
}
</script>
